export const arrayOrEmpty = (value) => (Array.isArray(value) ? value : [])

export const scrollToElement = (el, { offsetY = 135 } = {}) => {
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - offsetY
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}
